import { Colors } from '@/styles'

const fontColorMap = {
  light: Colors.white,
  dark: Colors.navy
}

export default fontColorMap
